import { useState } from 'react';
import { useAppContext } from '../../../Services/AppContext';

export default function useDiscoursePredefinedPhrases(
	getMyPhrasesQuery: any,
	customSkip?: number,
) {
	const { userData, workplaceId } = useAppContext();
	const [page, setPage] = useState(1);
	const getMyPhrases = (filter: any) => {
		const skip = customSkip || 20;
		getMyPhrasesQuery({
			userId: userData.id,
			workplaceId,
			pagination: {
				...filter.pagination,
				take: 20,
				skip: (page - 1) * skip,
			},
		});
	};

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	return { getMyPhrases, getNextPage, page, setPage };
}
